<template>
  <div class="no-data">
    <slot></slot>
    <img v-if="isImg" :src="noDataImg" alt="" />
    <span>{{ label || $t('noData') }}</span>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
    },
    isImg: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    noDataImg() {
      return require(`../../assets/no-data/no-data-3${this.darkModeImg}.png`);
    }
  }
};
</script>

<style lang="less" scoped>
.no-data {
  display: flex;
  flex-direction: column;
  align-items: center;
  img {
    margin-bottom: 10px;
    width: 20px;
    height: 20px;
  }
  span {
    font-size: 12px;
    // color: var(--no-data-color);
    color: var(--color-32);
    text-align: center;
    font-weight: 500;
  }
}
</style>
